import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/melonData";

function Brand() {
  return (
    <a href="#top" className="flex items-center gap-2.5 group shrink-0" aria-label="每日有瓜首页">
      <span className="relative flex w-9 h-9 items-center justify-center rounded-xl bg-primary-500 text-background-50 font-heading text-lg shadow-soft overflow-hidden">
        瓜
        <span className="absolute -bottom-2 -right-2 w-4 h-4 rounded-full bg-accent-400" />
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-xl text-foreground-950">每日有瓜</span>
        <span className="text-[11px] text-foreground-600 tracking-widest mt-1">一颗瓜 · 看到底</span>
      </span>
    </a>
  );
}

export default function MelonHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-background-50/92 backdrop-blur-md border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 md:px-6 h-[72px]">
        <Brand />

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap px-3.5 py-2 text-sm text-foreground-700 hover:text-foreground-950 rounded-md hover:bg-background-100 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 px-4 py-2.5 text-sm font-medium transition-colors"
          >
            <i className="ri-notification-3-line text-base" />
            订阅瓜报
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            className="lg:hidden inline-flex w-10 h-10 items-center justify-center rounded-lg text-foreground-800 hover:bg-background-100 transition-colors"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-background-200/70 bg-background-50 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-lg bg-primary-500 text-background-50 px-3 py-2.5 text-sm font-medium"
            >
              <i className="ri-notification-3-line text-base" />
              订阅瓜报
            </a>
          </div>
        </div>
      )}
    </header>
  );
}